import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  FormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FileUploadComponent } from '../../util/upload/file-upload.component';
import * as _ from 'lodash';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { DynamicFormEmbedComponent } from '../../util/dynamic-form-embed/dynamic-form-embed.component';
import {
  DynamicFormConfigurationView,
  DynamicFormView,
  EDynamicFormInputType,
  EDynamicFormSource,
} from '../../models/DynamicFormView';
import { NgxMaskConfig } from 'ngx-mask';

import { UtilityService } from '../../service/utility.service';
import { NotificationService } from '../../service/notification.service';
import { LoadingService } from '../../service/loading.service';
import Swal from 'sweetalert2';
import { VendorInformationChangeRequest } from '../../models/VendorInformationChangeRequest';
import { VendorInformationChangeRequestService } from '../../service/vendor-information-change-request.service';
import { UsState, vendorAddressAndContactType } from '../../models/Vendor';
import { routingNumberValidator } from '../../util/validator/routing-number.validator';
import { DocumentView } from '../../models/form/DocumentView';
const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
const maskConfig: Partial<NgxMaskConfig> = {
  validation: true,
  dropSpecialCharacters: false,
};

@Component({
  selector: 'app-information-change-request',
  standalone: true,
  imports: [
    NgxMaskDirective,
    DynamicFormEmbedComponent,
    FormsModule,
    FileUploadComponent,
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  templateUrl: './information-change-request.component.html',
  styleUrls: ['./information-change-request.component.css'],
})
export class InformationChangeRequestComponent implements OnInit {
  @ViewChild('documentsSection') documentsSection: ElementRef;
  form: FormGroup;
  statusform: FormGroup;
  contactForm: FormGroup;
  submitted = false;
  Status: string;
  CompletionDate: any;
  files: any[] = [];
  uploadedFiles: File[] = [];
  submittedContent = false;
  Contacts: any[] = [];
  isDocumentDeleted: any = false;
  deletedDocumentIds: string[] = [];
  vendorid: string[] = [];
  isCardBodyVisible = false;
  isEditing!: Boolean;
  item: VendorInformationChangeRequest = {} as VendorInformationChangeRequest;
  id!: string;
  readonly clientId!: string;
  additionaFields!: DynamicFormView;
  sourceId: number = EDynamicFormSource.VendorForm;
  prefixLabel: string = '';
  vendorAddress: FormArray;
  VendorAddresses: any[] = [];
  addressAndContactTypes = [
    { id: 1, name: 'Purchasing' },
    { id: 2, name: 'Remittance' },
  ];
  vendorAddressAndContactType = vendorAddressAndContactType;
  contacts = [
    { contactType: vendorAddressAndContactType.Purchasing },
    { contactType: vendorAddressAndContactType.Remittance },
  ];
  usStates: UsState[] = [];
  isCollapsed = true;
  canEdit: Boolean;
  currentStep: string;
  isRejected: boolean;
  canSubmit: boolean = true;
  showBank: boolean;
  constructor(
    private formBuilder: FormBuilder,
    public utilityService: UtilityService,
    private notificationService: NotificationService,
    private VendorInformationChangeRequestService: VendorInformationChangeRequestService,
    private spinner: LoadingService,
    private loadingService: LoadingService,
  ) {
    this.usStates = this.utilityService.getUsState();
    this.contactForm = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      contactName: [null, Validators.required],
      phone: [null, Validators.required],
      emailAddress: [null, [Validators.email, Validators.required]],
      contactType: [null, Validators.required],
    });

    this.form = this.formBuilder.group({
      id: ['00000000-0000-0000-0000-000000000000'],
      Name: [null, Validators.required],
      LegalName: [null, Validators.required],
      Address: [null, [Validators.maxLength(50), Validators.required]],
      AddressLine2: [null, Validators.maxLength(50)],
      isInternational: [false],
      City: [null, [Validators.maxLength(30), Validators.required]],
      State: ['AL', [Validators.required]],
      ZipCode: [
        null,
        [
          Validators.maxLength(10),
          Validators.pattern(/^[0-9-]*$/),
          Validators.required,
        ],
      ],
      Description: [null, Validators.maxLength(500)],
      W9Status: ['Yes'],
      FutureBidStatus: [null],
      W9StatusReason: [null],
      VendorType: [null],
      TradeBusinessEngaged: [null],
      ReceivesRentOrRoyaltyIncome: [null],
      ApplicableTaxIdentificationNumber: [null, [Validators.required]],
      SocialSecurityNumber: [null],
      EmployerIdentificationNumber: [null],
      Form1099Applicable: ['0'],
      paymentType: [''],
      deliveryMethod: ['Email', Validators.required],
      Form1099ApplicableOther: [null],
      IsIncorporated: [null],
      corporationType: [null],
      VendorDepartments: [null],
      OfferEarlyPaymentDiscount: [null],
      EarlyPaymentDiscountDescription: [null],
      PayViaACH: [null, [Validators.required]],
      BankName: [null],
      BankRoutingNumber: [null],
      BankAccountNumber: [null],
      BankAccountType: [null],
      BankAccountClass: [null],
      DigitalCheckEmailAddress: [null],
      ProvidesMerchandiseOrUtilities: [false],
      MinorityBusinessEnterprise: [false],
      requestedBy: ['system'],
      vendorW9File: new FormControl(null),
      voidedCheckFile: new FormControl(null),
      projectAgreement: new FormControl(null),
      attachments: new FormArray([]),
      MedicalLegalServicesStatus: [null],
      ExistingBusinessRelation: [null],
      isDraft: [true],
      additionalFieldValues: [null],
      vendorId: [null],
      vendorAddresses: this.formBuilder.array([]),
      isDuplicate: [false],
      vendorFormJson: [null],
      Contacts: [null],
    });

    this.form.get('PayViaACH')?.valueChanges.subscribe((val) => {
      this.form.get('BankName')?.clearValidators();
      this.form.get('BankRoutingNumber')?.clearValidators();
      this.form.get('BankAccountNumber')?.clearValidators();
      this.form.get('BankAccountType')?.clearValidators();
      this.form.get('BankAccountClass')?.clearValidators();
      if (val === 'true') {
        this.showBank = true;
        this.form
          .get('BankName')
          ?.setValidators([Validators.maxLength(50), Validators.required]);
        this.form
          .get('BankRoutingNumber')
          ?.setValidators([
            Validators.maxLength(25),
            Validators.required,
            routingNumberValidator(),
          ]);
        this.form
          .get('BankAccountNumber')
          ?.setValidators([Validators.maxLength(25), Validators.required]);
        this.form.get('BankAccountType')?.setValidators([Validators.required]);
        this.form.get('BankAccountClass')?.setValidators([Validators.required]);
      } else {
        this.showBank = false;
        this.form.get('BankName')?.setValue(null);
        this.form.get('BankRoutingNumber')?.setValue(null);
        this.form.get('BankAccountNumber')?.setValue(null);
        this.form.get('BankAccountType')?.setValue(null);
        this.form.get('BankAccountClass')?.setValue(null);
      }
      this.form.get('BankName')?.updateValueAndValidity();
      this.form.get('BankRoutingNumber')?.updateValueAndValidity();
      this.form.get('BankAccountNumber')?.updateValueAndValidity();
      this.form.get('BankAccountType')?.updateValueAndValidity();
      this.form.get('BankAccountClass')?.updateValueAndValidity();
    });
    this.vendorAddress = this.form.get('vendorAddresses') as FormArray;
    if (!this.id) {
      this.addDefaultAddresses();
    }

    this.statusform = this.formBuilder.group({
      vendorId: ['00000000-0000-0000-0000-000000000000'],
    });
  }

  setVendorW9FileValidator(status: string) {
    const vendorW9FileControl = this.form.get('vendorW9File');
    if (status === 'Yes') {
      const hasExistingAttachment = this.hasVendorW9Attachment();
      if (!hasExistingAttachment) {
        vendorW9FileControl?.setValidators([Validators.required]);
      } else {
        vendorW9FileControl?.clearValidators();
      }
    } else {
      vendorW9FileControl?.clearValidators();
    }
    vendorW9FileControl?.updateValueAndValidity();
  }

  ngOnInit() {
    const OldData = JSON.parse(
      localStorage.getItem('registrationData') || '{}',
    );

    // Pre-fill only from a full vendor form. An object without the address list
    // (an id/name/address profile) would throw here and stop this screen's own read.
    if (Array.isArray(OldData.vendorAddresses)) {
      this.changeRequestForm(OldData);
    }
    this.id = OldData.id;

    this.form.get('W9Status')!.valueChanges.subscribe((status: string) => {
      this.setVendorW9FileValidator(status);
    });

    this.statusform.get('vendorId')!.setValue(OldData.id);
    this.getFormStatus();

    const vendorId = JSON.parse(localStorage.getItem('vendorId') || 'null');
    this.VendorInformationChangeRequestService.getForm(vendorId).subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);
        this.form.get('vendorFormJson')?.setValue(JSON.stringify(data));
        this.changeRequestForm(data);
        this.form.get('vendorId')!.setValue(data.id);
        this.statusform.get('vendorId')!.setValue(data.id);
        this.disableTINFields();
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        this.notificationService.showError(err, 'Error');
      },
    );
  }

  ngAfterViewInit(): void {}

  private disableTINFields(): void {
    this.form.get('ApplicableTaxIdentificationNumber')?.disable();
    this.form.get('EmployerIdentificationNumber')?.disable();
    this.form.get('SocialSecurityNumber')?.disable();
  }

  get f() {
    return this.form.controls;
  }

  get cf() {
    return this.contactForm.controls;
  }

  onSubmitContent() {
    this.submittedContent = true;
    if (this.contactForm.invalid) {
      this.utilityService.getFormValidationErrors(this.contactForm);
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }
    const request = _.cloneDeep(this.contactForm.value);
    const contactFormValue = this.contactForm.value;
    this.Contacts.push(request);
    this.reSetContactForm();
    (this.form.get('Contacts') as FormArray).push(
      this.formBuilder.group(contactFormValue),
    );
  }

  reSetContactForm() {
    this.contactForm.reset();
    this.contactForm
      .get('id')
      ?.setValue('00000000-0000-0000-0000-000000000000');
    this.submittedContent = false;
  }

  resetForm() {
    while (this.filesArray.length) {
      this.filesArray.removeAt(0);
    }
    this.form.reset();
  }

  removeContent(index: number) {
    this.Contacts[index].isDeleted = true;
  }

  integrateAdditionalFields(event: any) {
    const values = event.values;
    if (values && values.length > 0) {
      values.forEach((value: any) => {
        this.form.addControl(
          value.tempLabel,
          new FormControl(value.value, value.validators),
        );
      });
      this.additionaFields = event.dynamicForm;
      this.prefixLabel = event.prefixLabel;

      if (this.isEditing) {
        this.disableAddtionalFields(true);
      }
    }
  }

  onDynamicformFileChange($event: any) {
    const control = this.form.get($event.propertyName);
    if (control) {
      if ($event.file) {
        control.patchValue($event.file);
      }
    } else {
      console.warn(`Form control ${$event.propertyName} not found.`);
    }
  }

  disableAddtionalFields(disable: boolean) {
    Object.keys(this.form.controls).forEach((controlName) => {
      if (controlName.includes(this.prefixLabel)) {
        disable
          ? this.form.controls[controlName].disable()
          : this.form.controls[controlName].enable();
      }
    });
  }

  async onSubmit() {
    this.submitted = true;
    this.updatePurchasingAddressToForm();
    if (this.Contacts.length > 0) {
      this.form.get('Contacts')?.setValue(this.Contacts);
    } else {
      this.notificationService.showError(
        'Please add at least one contact.',
        'Error',
      );
      return;
    }
    const W9StatusControl = this.form.get('W9Status')?.value;
    const ApplicableTaxIdentificationNumberControl = this.form.get(
      'ApplicableTaxIdentificationNumber',
    );
    const SocialSecurityNumberControl = this.form.get('SocialSecurityNumber');
    const EmployerIdentificationNumberControl = this.form.get(
      'EmployerIdentificationNumber',
    );

    ApplicableTaxIdentificationNumberControl?.clearValidators();
    SocialSecurityNumberControl?.clearValidators();
    EmployerIdentificationNumberControl?.clearValidators();

    const taxIdType = ApplicableTaxIdentificationNumberControl?.value;
    if (taxIdType === 'Social Security Number') {
      SocialSecurityNumberControl?.setValidators([Validators.required]);
    } else if (taxIdType === 'Employer Identification Number') {
      EmployerIdentificationNumberControl?.setValidators([Validators.required]);
    }

    SocialSecurityNumberControl?.updateValueAndValidity();
    EmployerIdentificationNumberControl?.updateValueAndValidity();

    if (this.form.invalid) {
      this.notificationService.showError('Fill all required fields', 'Error');
      return;
    }

    const ssn =
      this.form.get('SocialSecurityNumber')?.value?.replace(/-/g, '') || '';
    this.form.get('SocialSecurityNumber')?.setValue(ssn);
    const ein =
      this.form.get('EmployerIdentificationNumber')?.value?.replace(/-/g, '') ||
      '';
    this.form.get('EmployerIdentificationNumber')?.setValue(ein);

    this.assembleDataforSubmit();
    if (this.form.get('MedicalLegalServicesStatus')?.value === 'Yes') {
      this.form.get('Form1099Applicable')?.setValue('Form 1099-MISC');
    }

    const request = _.cloneDeep(this.form.getRawValue());
    let requestCall;
    this.spinner.OnLoading.emit(true);
    requestCall = this.VendorInformationChangeRequestService.createForm(
      request,
      this.prefixLabel,
    );
    requestCall.subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);
        if (
          data.confirmation ===
          'There is some issue in saving, please try again later!'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'There is some issue in saving, please try again later!',
          });
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Vendor Information Change Request is submitted successfuly!',
          }).then(() => {
            window.location.reload();
          });
        }
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        Swal.fire({
          icon: 'error',
          title: 'Submission Error',
          text: 'An error occurred while submitting the form. Please try again later.',
        });
        console.error('Form submission error:', err);
      },
    );
  }

  updatePurchasingAddressToForm(): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const purchasingAddress = addresses.controls.find(
      (address) =>
        parseInt(address.get('addressType')?.value, 10) ===
          vendorAddressAndContactType.Purchasing &&
        address.get('isDefaultAddress')?.value,
    );
    if (purchasingAddress) {
      this.form
        .get('Address')
        ?.setValue(purchasingAddress.get('address')?.value);
      this.form
        .get('AddressLine2')
        ?.setValue(purchasingAddress.get('addressLine2')?.value);
      this.form.get('City')?.setValue(purchasingAddress.get('city')?.value);
      this.form.get('State')?.setValue(purchasingAddress.get('state')?.value);
      this.form
        .get('country')
        ?.setValue(purchasingAddress.get('country')?.value);
      this.form
        .get('ZipCode')
        ?.setValue(purchasingAddress.get('zipCode')?.value);
    }
  }

  assembleDataforSubmit() {
    this.additionaFields?.dynamicFormConfigurations?.forEach(
      (config: DynamicFormConfigurationView) => {
        let value = this.form.get(config.tempLabel)?.value;

        config.value =
          config.dynamicFormInputTypeId === EDynamicFormInputType.FileInput
            ? config.tempLabel.slice(this.prefixLabel.length) +
              '--' +
              value.name
            : value;

        if (config.dynamicFormInputTypeId === EDynamicFormInputType.Dropdown) {
          config.optionId = value;
        }
      },
    );

    this.form.addControl(
      'additionalField',
      this.formBuilder.group({
        source: '',
        sourceId: 1,
        dynamicFormConfigurations: this.formBuilder.array([]),
      }),
    );

    this.additionaFields?.dynamicFormConfigurations?.forEach(
      (config: DynamicFormConfigurationView) => {
        let { dynamicFormConfigurationOptions, ...configWithoutOptions } =
          config;
        (
          this.form.get(
            'additionalField.dynamicFormConfigurations',
          ) as FormArray
        ).push(this.formBuilder.group(configWithoutOptions));
      },
    );
  }

  onAdditionalFileChanged(file: any, i: number) {
    let currentVal = this.filesArray.controls[i].value;
    currentVal.file = file;
    this.filesArray.controls[i].patchValue(currentVal);
  }

  onFileChange($event: any, propertyName: string, maxSizeMB: number) {
    const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes

    if ($event && $event.size > maxSizeBytes) {
      this.notificationService.showError(
        `File is over the size limit. Please upload a file under ${maxSizeMB}MB.`,
        'Error',
      );
      this.f[propertyName].setValue(null); // Clear the form control
      return;
    }

    this.f[propertyName].setValue($event); // Set the valid file in the form
  }
  get filesArray(): FormArray {
    return this.form.controls['attachments'] as FormArray;
  }

  async onFileSelected(
    event: any,
    fileInput: HTMLInputElement,
  ): Promise<void> {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        if (this.utilityService.isFileEmptyOrCorrupted(file)) {
          this.notificationService.showError(
            this.utilityService.getCorruptedOrEmptyFileMessage(),
            'Invalid File',
          );
          continue;
        }

        if (!this.utilityService.isFileTypeAllowed(file)) {
          this.notificationService.showError(
            this.utilityService.getUnsupportedFileTypeMessage(file.name),
            'Invalid File Type',
          );
          continue;
        }

        const restrictedZipMessage =
          await this.utilityService.getRestrictedZipContentMessage(file);
        if (restrictedZipMessage) {
          this.notificationService.showError(
            restrictedZipMessage,
            'Invalid File Type',
          );
          continue;
        }

        let currentFileCount = this.filesArray.controls.length + 1;
        this.filesArray.push(
          new FormControl({
            label: `File ${currentFileCount}`,
            file,
            order: currentFileCount,
          }),
        );
      }
    }

    fileInput.value = '';
  }

  removeFile(index: number) {
    if (this.filesArray.controls.length > 0) {
      this.filesArray.removeAt(index);
    }
  }

  private changeRequestForm(data: VendorInformationChangeRequest) {
    this.loadingService.OnLoading.emit(false);
    this.item = data;
    this.form.get('isDraft')!.setValue(data.isDraft);
    this.form.get('Name')!.setValue(data.name);
    this.form.get('LegalName')!.setValue(data.legalName);
    this.form.get('Address')!.setValue(data.address);
    this.form.get('AddressLine2')!.setValue(data.addressLine2);
    this.form.get('City')!.setValue(data.city);
    this.form.get('State')!.setValue(data.state);
    this.form.get('ZipCode')!.setValue(data.zipCode);
    this.form.get('Description')!.setValue(data.description);
    this.form.get('W9Status')!.setValue(data.w9Status);
    this.form.get('FutureBidStatus')!.setValue(data.futureBidStatus);
    this.form.get('W9StatusReason')!.setValue(data.w9StatusReason);
    this.form.get('TradeBusinessEngaged')!.setValue(data.tradeBusinessEngaged);
    let vendorId = JSON.parse(localStorage.getItem('vendorId') || '{}');
    this.statusform.get('vendorId')!.setValue(vendorId);
    this.form.get('vendorId')!.setValue(vendorId);
    this.form
      .get('ReceivesRentOrRoyaltyIncome')!
      .setValue(data.receivesRentOrRoyaltyIncome);
    this.form
      .get('ApplicableTaxIdentificationNumber')!
      .setValue(data.applicableTaxIdentificationNumber);
    this.form.get('SocialSecurityNumber')!.setValue(data.socialSecurityNumber);
    this.form
      .get('EmployerIdentificationNumber')!
      .setValue(data.employerIdentificationNumber);
    this.form.get('Form1099Applicable')!.setValue(data.form1099Applicable);
    this.form
      .get('Form1099ApplicableOther')!
      .setValue(data.form1099ApplicableOther);
    this.form.get('IsIncorporated')!.setValue(data.isIncorporated);
    this.form.get('corporationType')!.setValue(data.corporationType);
    this.form.get('VendorDepartments')!.setValue(data.vendorDepartments);
    this.form
      .get('MedicalLegalServicesStatus')!
      .setValue(data.medicalLegalServicesStatus);
    this.form.get('PayViaACH')!.setValue(data.payViaACH?.toString());
    this.form
      .get('ProvidesMerchandiseOrUtilities')!
      .setValue(data.providesMerchandiseOrUtilities?.toString());
    this.form.get('BankName')!.setValue(data.bankName);
    this.form.get('BankRoutingNumber')!.setValue(data.bankRoutingNumber);
    this.form.get('BankAccountNumber')!.setValue(data.bankAccountNumber);
    this.form.get('BankAccountType')!.setValue(data.bankAccountType);
    this.form.get('BankAccountClass')!.setValue(data.bankAccountClass);
    this.form
      .get('DigitalCheckEmailAddress')!
      .setValue(data.digitalCheckEmailAddress);
    this.form.get('VendorType')!.setValue(data.vendorType);
    this.form
      .get('MinorityBusinessEnterprise')!
      .setValue(data.minorityBusinessEnterprise?.toString());
    this.form
      .get('ExistingBusinessRelation')!
      .setValue(data.existingBusinessRelation?.toString());
    this.form.get('paymentType')!.setValue(data.paymentType);
    this.form.get('deliveryMethod')!.setValue(data.deliveryMethod);
    this.form
      .get('additionalFieldValues')!
      .setValue(data.additionalFieldValues);

    if (data.requestedBy) {
      this.form.get('requestedBy')!.setValue(data.requestedBy);
    }

    const vendorAddresses = this.form.get('vendorAddresses') as FormArray;
    vendorAddresses.clear();
    const sortedAddresses = [...data.vendorAddresses].sort(
      (a, b) => (b.isDefaultAddress ? 1 : 0) - (a.isDefaultAddress ? 1 : 0),
    );

    sortedAddresses.forEach((address) => {
      const addressGroup = this.formBuilder.group({
        id: [address.id || EMPTY_GUID],
        addressType: [address.addressType],
        address: [address.address],
        addressLine2: [address.addressLine2],
        city: [address.city],
        state: [address.state],
        country: [address.country || 'USA'],
        zipCode: [address.zipCode],
        customerAccountNumber: [address.customerAccountNumber ?? null, Validators.maxLength(50)],
        isInternational: [address.isInternational || false],
        isSameAddress: [address.isSameAddress || false],
        isDefaultAddress: [address.isDefaultAddress || false],
      });
      vendorAddresses.push(addressGroup);
    });

    this.Contacts = data.contacts;
    this.VendorAddresses = data.vendorAddresses;
    this.item.documents = data.documents;

    this.isRejected =
      this.item.declinedReason != null && this.item.declinedReason.length > 0;
    let currentStep = this.item?.workflowSteps?.find((t) => t.isCurrent);
    if (currentStep != null) {
      this.currentStep = currentStep.name;
    }
  }

  getFormStatus() {
    let request = _.cloneDeep(this.statusform.value);
    this.spinner.OnLoading.emit(true);
    this.VendorInformationChangeRequestService.getFormStatus(
      request,
      this.prefixLabel,
    ).subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);

        if (!data || !data.confirmation) {
          this.Status = 'No Request found';
          this.canSubmit = true;
          return;
        }

        const confirmation = data.confirmation;

        if (confirmation.startsWith('Vendor Change Request is Completed')) {
          this.Status = 'Your Request is Completed';
          this.canSubmit = true;

          const colonIndex = confirmation.indexOf(':');
          if (colonIndex !== -1 && confirmation.length > colonIndex + 1) {
            const datePart = confirmation.substring(colonIndex + 1).trim();
            this.CompletionDate = datePart;
          } else {
            this.CompletionDate = 'Unknown';
          }
        } else if (confirmation === 'Vendor Change Request is In Progress') {
          this.Status = 'Your Request is In progress';
          this.canSubmit = false;
          this.CompletionDate = null;
        } else if (
          confirmation === 'Vendor Change Request is Denied' ||
          confirmation.startsWith('Vendor Change Request Form is Denied:')
        ) {
          this.Status = 'Your Request was Denied';
          this.canSubmit = true;
          this.CompletionDate = null;
        } else if (confirmation === 'Vendor Change Request Form is Inactive') {
          this.Status = 'Your Request is Inactive';
          this.canSubmit = false;
          this.CompletionDate = null;
        } else if (confirmation === 'No Change request found') {
          this.Status = 'No Request found';
          this.canSubmit = true;
          this.CompletionDate = null;
        } else {
          this.Status = 'No Request found';
          this.canSubmit = true;
          this.CompletionDate = null;
        }
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        this.Status = 'No Request found';
        this.canSubmit = true;
        this.CompletionDate = null;
        this.notificationService.showError(err, 'Error');
      },
    );
  }

  createAddress(type: string, isDefault = false): FormGroup {
    return this.formBuilder.group({
      id: [EMPTY_GUID],
      addressType: [type, Validators.required],
      address: [null, [Validators.maxLength(50), Validators.required]],
      addressLine2: [null, Validators.maxLength(50)],
      city: [null, [Validators.maxLength(30), Validators.required]],
      state: ['', [Validators.required]],
      country: ['USA', Validators.required],
      zipCode: [
        null,
        [
          Validators.maxLength(10),
          Validators.pattern(/^[0-9-]*$/),
          Validators.required,
        ],
      ],
      customerAccountNumber: [null, Validators.maxLength(50)],
      isInternational: [false],
      isSameAddress: [false],
      isDefaultAddress: [isDefault],
    });
  }

  addDefaultAddresses(): void {
    if (!this.id && this.vendorAddress.length === 0) {
      const addresses = this.form.get('vendorAddresses') as FormArray;
      addresses.push(
        this.createAddress(
          vendorAddressAndContactType.Purchasing.toString(),
          true,
        ),
      );
      addresses.push(
        this.createAddress(
          vendorAddressAndContactType.Remittance.toString(),
          true,
        ),
      );
    }
  }

  addAddress(): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    addresses.push(this.createAddress(''));
  }
  removeAddress(index: number): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const address = addresses.at(index);
    if (address.get('isDefaultAddress')?.value) {
      this.notificationService.showError(
        'Default addresses cannot be removed.',
        'Error',
      );
      return;
    }
    addresses.removeAt(index);
  }
  onChangeInternationalAddress(index: number) {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const currentAddress = addresses.at(index);
    if (currentAddress.get('isInternational')?.value) {
      currentAddress
        .get('state')
        ?.setValue(
          this.getSelectedState(currentAddress.get('state')?.value)?.name,
        );
      currentAddress.get('country')?.setValue('');
      currentAddress
        .get('zipCode')
        ?.setValidators([
          Validators.maxLength(10),
          Validators.pattern(/^[a-zA-Z0-9- ]*$/),
          Validators.required,
        ]);
    } else {
      currentAddress
        .get('state')
        ?.setValue(
          this.getSelectedState(currentAddress.get('state')?.value)
            ?.abbreviation,
        );
      currentAddress.get('country')?.setValue('USA');
      currentAddress
        .get('zipCode')
        ?.setValidators([
          Validators.maxLength(10),
          Validators.pattern(/^[0-9-]*$/),
          Validators.required,
        ]);
    }
    currentAddress.get('zipCode')?.updateValueAndValidity();
  }
  public getSelectedState(value: string): UsState | null {
    if (this.usStates && value) {
      const state: UsState | undefined = this.usStates.find(
        (s) => s.abbreviation === value || s.name === value,
      );
      return state || null;
    }
    return null;
  }
  onSameAddressCheck(index: number): void {
    const addresses = this.form.get('vendorAddresses') as FormArray;
    const currentAddress = addresses.at(index);
    if (currentAddress.get('isSameAddress')?.value) {
      const purchasingAddress = addresses.controls.find(
        (addr) =>
          addr.get('addressType')?.value ===
          vendorAddressAndContactType.Purchasing,
      );
      if (purchasingAddress) {
        currentAddress
          .get('address')
          ?.setValue(purchasingAddress.get('address')?.value);
        currentAddress
          .get('addressLine2')
          ?.setValue(purchasingAddress.get('addressLine2')?.value);
        currentAddress
          .get('city')
          ?.setValue(purchasingAddress.get('city')?.value);
        currentAddress
          .get('state')
          ?.setValue(purchasingAddress.get('state')?.value);
        currentAddress
          .get('country')
          ?.setValue(purchasingAddress.get('country')?.value);
        currentAddress
          .get('zipCode')
          ?.setValue(purchasingAddress.get('zipCode')?.value);
        currentAddress
          .get('isInternational')
          ?.setValue(purchasingAddress.get('isInternational')?.value);
      } else {
        this.notificationService.showError(
          'No Purchasing address found to set as the same address.',
          'Error',
        );
      }
    } else {
      currentAddress.get('address')?.reset();
      currentAddress.get('addressLine2')?.reset();
      currentAddress.get('city')?.reset();
      currentAddress.get('state')?.reset();
      currentAddress.get('country')?.setValue('USA');
      currentAddress.get('zipCode')?.reset();
    }
  }
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  onW9StatusChanged() {
    this.form.get('W9StatusReason')?.setValue('');
  }

  incorporatedChange() {
    const corporationType = this.form.get('corporationType');
    if (this.form.get('IsIncorporated')?.value === 'Yes') {
      corporationType?.setValidators([Validators.required]);
    } else {
      corporationType?.clearValidators();
      this.form.get('corporationType')?.setValue('');
    }
    corporationType?.updateValueAndValidity();
    this.form1099ApplicableAutoPopulate();
  }

  form1099ApplicableAutoPopulate() {
    if (
      this.form.get('ProvidesMerchandiseOrUtilities')?.value === 'true' ||
      this.form.get('IsIncorporated')?.value === 'Yes'
    ) {
      this.form.get('Form1099Applicable')?.setValue('N/A');
    } else if (
      this.form.get('ReceivesRentOrRoyaltyIncome')?.value === 'Yes' ||
      this.form.get('MedicalLegalServicesStatus')?.value === 'Yes'
    ) {
      this.form.get('Form1099Applicable')?.setValue('Form 1099-MISC');
    } else {
      this.form.get('Form1099Applicable')?.setValue('Form 1099-NEC');
    }
    this.form.get('paymentType')?.setValue('');
  }

  hasVendorW9Attachment(): DocumentView | null {
    return (
      this.item?.documents?.find(
        (x) =>
          x.documentType?.toLowerCase() === 'vendor w9' ||
          x.documentType?.toLowerCase() === 'files',
      ) ?? null
    );
  }

  onZipInput(control: AbstractControl | null, isInternational = false): void {
    if (!control) {
      return;
    }
    const value = control.value ?? '';
    const pattern = isInternational ? /[^a-zA-Z0-9\- ]/g : /[^0-9-]/g;
    const sanitized =
      typeof value === 'string' ? value.replace(pattern, '') : value;
    if (sanitized !== value) {
      control.setValue(sanitized, { emitEvent: false });
    }
  }
}
